import { useEffect, useRef, useState } from "react";
import { Button, Container, Modal, Spinner } from "react-bootstrap";
import { RiCloseCircleLine, RiImage2Line, RiFile2Line } from "react-icons/ri";
import { customAction } from "../../actions/AuthActions";
import { useSelector } from "react-redux";
import { notify } from "../../actions/notify";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { ckEditorConfiguration, formatPrice, getMediaUrl, isImage, preventInvalidNumberInput, RenderAsterisk, truncateString } from "../../utils";
import CustomTable from "./CustomTable";
import { MdCheckBox, MdCheckBoxOutlineBlank } from "react-icons/md";
import CreatableSelect from "react-select/creatable";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const invoicePaymentRowHeadings = [
  { title: "Invoice", key: "invoice_details.invoice_number" },
  { title: "TDS %", key: "tds_percent" },
  { title: "Exchange Rate", key: "exchange_rate" },
  { title: "Mode of Payment", key: "mode_of_payment" },
  { title: "Amount", key: "amount_paid" },
  { title: "Date", key: "payment_date" },
  { title: "Action", key: "actions" },
];

const delayChargesRowHeadings = [
  { title: "Invoice", key: "invoice_number" },
  { title: "Amount", key: "daily_charge" },
  { title: "Interest %", key: "applied_interest_rate" },
  { title: "Date", key: "created_on" },
];

const statusOptions = ["PAID", "PENDING"];
const modeOptions = [
  { value: "CASH_PAYMENT", label: "Cash Payment" },
  { value: "BANK_TRANSFER", label: "Bank Transfer" },
  { value: "WISE_TRANSFER", label: "Wise Transfer" },
  { value: "ONLINE_STRIPE", label: "Online Stripe" },
  { value: "PayPal", label: "PayPal" },
  { value: "CHEQUE_DEOPOSIT", label: "Cheque Deposit" },
  { value: "WIRE_TRANSFER", label: "Wire Transfer" },
];

const roleTypeOptions = ["ADMIN", "EMPLOYEE", "PROJECT_MANAGER"];

const gstSlabOptions = [
  { value: "0", label: "0%" },
  { value: "5", label: "5%" },
  { value: "12", label: "12%" },
  { value: "18", label: "18%" },
  { value: "28", label: "28%" },
];

const CustomAddBox = ({ show, onHide, onSubmit, title, itemId = null, fetchData, projectId, item, action }) => {
  const navigate = useNavigate();
  const [id, setId] = useState(itemId);
  const token = useSelector((state) => state.authReducer.token);
  const [name, setName] = useState("");
  const [file, setFile] = useState(null);
  const fileInputRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [saveAddLoading, setSaveAddLoading] = useState(false);
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [vendorOptions, setVendorOptions] = useState([]);
  const [expenseCategoyrOptions, setExpenseCategoryOptions] = useState([]);

  const [projectOptions, setProjectOptions] = useState([]);
  const [employee, setEmployee] = useState("");
  const [leavePolicyData, setLeavePolicyData] = useState({
    year: "",
    total_leave_days: "",
  });
  const [fetchAgain, setFetchAgain] = useState(false);

  const [leaveTypeData, setLeaveTypeData] = useState({
    name: "",
    status: true,
    is_paid: true,
    leave_policy: "",
    carry_forward_days: 0,
    total_leave_days: "",
    minimum_notice_days: 0,
  });

  const [amountPaid, setAmountPaid] = useState(item?.remaining_amount ? parseFloat(item?.remaining_amount)?.toFixed(2) : "");
  const [tds, setTds] = useState({ value: false, label: "No" });
  const [amountReceivedInINR, setAmountReceivedInINR] = useState("");
  const [tdsPercent, setTdsPercent] = useState("");
  const [gstPaid, setGstPaid] = useState("");
  const [amountDeducted, setAmountDeducted] = useState("");
  const [modeOfPayment, setModeOfPayment] = useState("");
  const [paymentDate, setPaymentDate] = useState("");
  const [invoiceType, setInvoiceType] = useState("");
  const [invoiceData, setInvoiceData] = useState("");
  const [roleType, setRoleType] = useState({
    value: "EMPLOYEE",
    label: "EMPLOYEE",
  });

  const [vendor, setVendor] = useState("");
  const [refNumber, setRefNumber] = useState("");
  const [invoiceDate, setInvoiceDate] = useState("");
  const [dueDate, setDueDate] = useState("");
  const [amount, setAmount] = useState("");
  const [expensePaymentDate, setExpensePaymentDate] = useState("");
  const [project, setProject] = useState("");
  const [status, setStatus] = useState("");
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [send, setSend] = useState(false);
  const [leavePolicyOptions, setLeavePolicyOptions] = useState([]);
  const [leaveTypeOptions, setLeaveTypeOptions] = useState([]);
  const [remark, setRemark] = useState("");
  const [expenseCategory, setExpenseCategory] = useState("");
  const [sgst, setSgst] = useState("");
  const [cgst, setCgst] = useState("");
  const [igst, setIgst] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [gstSlab, setGstSlab] = useState("");
  const [isRcmApplicable, setIsRcmApplicable] = useState(false);

  useEffect(() => {
    if (amountPaid) {
      let tds_percent = parseFloat(tdsPercent) / 100;
      let amountPaidFloat = parseFloat(amountPaid);
      let subTotalFloat = parseFloat(invoiceData ? invoiceData?.sub_total : item?.sub_total);
      let totalFloat = parseFloat(invoiceData ? invoiceData?.total : item?.total);
      let percent = subTotalFloat / totalFloat;
      let subtotalPaid = amountPaidFloat * percent;
      let tdsAmount = (subtotalPaid * tds_percent).toFixed(2);
      let gstPaid = amountPaidFloat - subtotalPaid;
      setGstPaid(parseFloat(gstPaid));

      const validTdsAmount = tdsAmount !== undefined && tdsAmount !== null && tdsAmount !== "" ? parseFloat(tdsAmount) : 0;
      setAmountDeducted(isNaN(validTdsAmount) ? 0 : validTdsAmount);
    }
  }, [tdsPercent, amountPaid]);

  useEffect(() => {
    if (item) {
      if (title === "Register Payment") {
        setInvoiceType(item?.invoice_type ? item?.invoice_type : item?.invoice_details ? item?.invoice_details?.invoice_type : "");
        if (item?.project_array?.currency?.code === "INR") {
          setAmountReceivedInINR("");
        }
      } else {
        const selectedOffice = item?.office_array;
        const selectedCLient = item?.project_array?.client_array;
        if (selectedCLient && selectedOffice) {
          if (
            selectedCLient?.billing_address_array?.country_name?.toLowerCase() === "india" &&
            selectedOffice?.address_array?.country_name?.toLowerCase() === "india"
          ) {
            if (selectedCLient?.billing_address_array?.state_name?.toLowerCase() === selectedOffice?.address_array?.state_name?.toLowerCase()) {
              setInvoiceType("SAME_STATE");
            } else {
              setInvoiceType("INTER_STATE");
            }
          } else {
            setInvoiceType("FOREIGN");
          }
        }
      }
    }
  }, [item]);

  useEffect(() => {
    setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (id) {
      if (title === "Team") {
        fetchTeam();
      }
      if (title === "Finance - Expenses" || title === "Expenses" || title === "Expense") {
        fetchExpense();
      }
    }
    if (title === "New Member") {
      fetchEmployees();
    }
    if (title === "Finance - Expenses" || title === "Expenses" || title === "Expense") {
      fetchVendors();
      fetchProjectOptions();
      fetchExpenseCategories();

      // If user just created a vendor from Vendors page, auto-select it here.
      const raw = sessionStorage.getItem("pp_new_vendor");
      if (raw) {
        try {
          const created = JSON.parse(raw);
          if (created?.id) {
            setVendor({
              value: created.id,
              label: created.name || "New Vendor",
            });
            fetchVendors();
          }
        } catch (e) {
          // ignore
        } finally {
          sessionStorage.removeItem("pp_new_vendor");
        }
      }
    }
    if (itemId && title === "Register Payment" && action === "edit") {
      fetchRegisteredPayment();
    }
    if (title === "Role") {
      if (itemId) {
        fetchRole();
      }
    }
    if (title === "Leave Policy" || title === "Leave Policie") {
      if (itemId) {
        fetchLeavePolicy();
      }
    }
    if (title === "Leave Type") {
      if (itemId) {
        fetchLeaveTypePolicyDetails();
      }
      fetchLeavePolicyOptions();
      fetchLeaveTypeOptions();
    }
  }, [title]);

  useEffect(() => {
    if (!(title === "Finance - Expenses" || title === "Expenses" || title === "Expense")) {
      return;
    }

    const handleFocus = () => {
      const raw = sessionStorage.getItem("pp_new_vendor");
      if (!raw) return;

      try {
        const created = JSON.parse(raw);
        if (created?.id) {
          setVendor({
            value: created.id,
            label: created.name || "New Vendor",
          });
          fetchVendors();
        }
      } catch (e) {
        // ignore
      } finally {
        sessionStorage.removeItem("pp_new_vendor");
      }
    };

    window.addEventListener("focus", handleFocus);
    return () => window.removeEventListener("focus", handleFocus);
  }, [title]);

  useEffect(() => {
    if (title === "Finance - Expenses" || title === "Expenses" || title === "Expense") {
      const amt = parseFloat(amount) || 0;
      if (amt && vendor?.value && gstSlab?.value) {
        const selectedVendor = vendorOptions?.find((v) => v.id == vendor.value);
        // Vendor options not loaded yet (e.g. just after opening the edit
        // modal) — don't wipe the fetched GST values with zeroes.
        if (!selectedVendor) return;
        const officeLocation = selectedVendor?.office_location_array; // assuming 1 item
        const { sgst, cgst, igst, totalAmount } = handleGSTCalculation(amt, gstSlab?.value, selectedVendor, officeLocation);

        setSgst(sgst.toFixed(2));
        setCgst(cgst.toFixed(2));
        setIgst(igst.toFixed(2));
        setTotalAmount(totalAmount.toFixed(2));
      } else {
        if (amount) {
          const sgstNum = parseFloat(sgst) || 0;
          const cgstNum = parseFloat(cgst) || 0;
          const igstNum = parseFloat(igst) || 0;

          setTotalAmount((amt + sgstNum + cgstNum + igstNum).toFixed(2));
        }
      }
    }
  }, [amount, gstSlab, vendor]);

  useEffect(() => {
    if (title === "Finance - Expenses" || title === "Expenses" || title === "Expense") {
      if (status?.value !== "PAID") {
        setExpensePaymentDate("");
      }
    }
  }, [status, title]);

  useEffect(() => {
    if (fetchAgain) {
      fetchData();
    }
  }, [fetchAgain]);

  const getStateCode = (gstNumber) => gstNumber?.substring(0, 2);

  const handleGSTCalculation = (amount, gstSlabValue, vendor, office) => {
    // console.log(amount, gstSlabValue, vendor, office);
    if (!amount || !gstSlabValue || !vendor?.gst_number || !office?.gst) {
      return { sgst: 0, cgst: 0, igst: 0, totalAmount: amount || 0 };
    }

    const gstPercent = parseFloat(gstSlabValue);
    const gstAmount = (amount * gstPercent) / 100;

    const vendorState = getStateCode(vendor?.gst_number);
    const officeState = getStateCode(office?.gst);
    console.log(vendorState, officeState);
    let sgst = 0,
      cgst = 0,
      igst = 0;

    if (vendorState === officeState) {
      // Same state → split equally between SGST & CGST
      sgst = gstAmount / 2;
      cgst = gstAmount / 2;
    } else {
      // Different states → IGST only
      igst = gstAmount;
    }

    const totalAmount = parseFloat(amount) + gstAmount;

    return { sgst, cgst, igst, totalAmount };
  };

  const fetchLeaveTypePolicyDetails = async () => {
    const response = await customAction(`leave/leave-policy-by-type/${id}`, "fetch", null, token, "Leave Policy");
    if (response) {
      let data = response;
      setLeaveTypeData({
        carry_forward_days: data?.carry_forward_days || "",
        minimum_notice_days: data?.minimum_notice_days || 0,
        total_leave_days: data?.total_leave_days || "",
        leave_policy: data?.leave_policy || "",
        name: {
          value: data?.leave_type,
          label: data?.leave_type_details?.name,
        },
        is_paid: data?.leave_type_details?.is_paid,
        status: data?.leave_type_details?.status,
        id: data?.id,
      });
    }
  };

  const fetchLeaveTypeOptions = async () => {
    const response = await customAction(`leave/leave-type?page_size=all`, "fetch", null, token, "Leave Type");
    if (response) {
      const options = response.map((policy) => ({
        value: policy.id,
        label: policy.name,
      }));

      setLeaveTypeOptions(options);
    }
  };

  const fetchLeavePolicyOptions = async () => {
    const response = await customAction(`leave/leave-policy?page_size=all`, "fetch", null, token, "Leave Policy");
    if (response) {
      const options = response.map((policy) => ({
        value: policy.id,
        label: policy.year,
      }));

      setLeavePolicyOptions(options);
    }
  };

  const fetchLeavePolicy = async () => {
    const response = await customAction(`leave/leave-policy/${id}`, "fetch", null, token, "Leave Policy");
    if (response) {
      setLeavePolicyData({ ...response });
    }
  };

  const fetchExpense = async () => {
    const response = await customAction(`expense/expense/${id}`, "fetch", null, token, "Expense");
    if (response) {
      setRefNumber(response?.ref_number);
      setVendor({
        value: response?.vendor,
        label: response?.vendor_array?.name,
      });
      setExpenseCategory({
        value: response?.category,
        label: response?.category_name,
      });
      setInvoiceDate(response?.bill_date);
      setDueDate(response?.due_date);
      // The Amount input holds the taxable value (excluding GST);
      // `amount` from the API is the GST-inclusive bill total.
      setAmount(response?.amount_excl_gst);
      response?.project &&
        setProject({
          value: response?.project,
          label: response?.project_array?.title,
        });
      setStatus({
        value: response?.status,
        label: response?.status,
      });
      setExpensePaymentDate(response?.payment_date || "");
      setFile(response?.file);
      setRemark(response?.remark || "");
      const gst = response?.gst_slab?.split(".")[0];
      setGstSlab({
        value: gst,
        label: gstSlabOptions?.find((s) => s.value == gst)?.label,
      });
      setSgst(response?.sgst);
      setCgst(response?.cgst);
      setIgst(response?.igst);
      setTotalAmount(response?.amount);
      setIsRcmApplicable(response?.is_rcm_applicable || false);
    }
  };

  const fetchEmployees = async () => {
    const response = await customAction("employee/employee?page_size=all&status=ACTIVE", "fetch", null, token, "Employee option");
    if (response) {
      setEmployeeOptions(response);
    }
  };

  const fetchTeam = async () => {
    const response = await customAction(`employee/team/${id}`, "fetch", null, token, "Team");
    if (response) {
      setName(response?.name);
    }
  };

  const fetchRole = async () => {
    const response = await customAction(`employee/role/${id}`, "fetch", null, token, "Role");
    if (response) {
      setName(response?.name);
      setRoleType({
        value: response?.role_type,
        label: response?.role_type?.split("_").join(" "),
      });
    }
  };
  const fetchExpenseCategories = async () => {
    const response = await customAction(`expense/expense-category?page_size=all`, "fetch", null, token, "Team");
    if (response) {
      setExpenseCategoryOptions(response);
    }
  };

  const fetchVendors = async () => {
    const response = await customAction(`vendor/vendor?page_size=all`, "fetch", null, token, "Team");
    if (response) {
      setVendorOptions(response);
    }
  };

  const fetchProjectOptions = async () => {
    const response = await customAction(`project/project?page_size=all`, "fetch", null, token, "Team");
    if (response) {
      let selectedProject = null;
      if (projectId) {
        selectedProject = response.find((item) => item.id == projectId);
        if (selectedProject) {
          setProject({
            value: selectedProject.id,
            label: selectedProject.title,
          });
        }
      }
      setProjectOptions(response);
    }
  };

  const fetchRegisteredPayment = async () => {
    const response = await customAction(`invoice/payments/${itemId}`, "fetch", null, token, "Payment");
    if (response) {
      setAmountPaid(response?.amount_paid);
      setAmountReceivedInINR(response?.amount_received_in_inr || "");
      response?.mode_of_payment &&
        setModeOfPayment({
          value: modeOptions?.find((item) => item?.label === response?.mode_of_payment).value,
          label: response?.mode_of_payment,
        });
      setPaymentDate(response?.payment_date);
      setInvoiceType(response?.invoice_details?.invoice_type);
      setTds({ value: response?.tds, label: response?.tds ? "Yes" : "No" });
      setTdsPercent(response?.tds_percent);
      setAmountDeducted(response?.amount_deducted);
      setInvoiceData(response?.invoice_details);
    }
  };

  const handleSelectChange = (selectedOption) => {
    setLeaveTypeData({ ...leaveTypeData, name: selectedOption?.label || "" });

    if (selectedOption?.__isNew__) {
      setLeaveTypeOptions((prev) => [
        ...prev,
        {
          value: selectedOption.label.toLowerCase(),
          label: selectedOption.label,
        },
      ]);
    }
    handleInputChange(
      null,
      "leave-type",
      "name",
      selectedOption?.label
        ? {
            value: selectedOption?.label?.toLowerCase(),
            label: selectedOption?.label,
          }
        : null,
    );
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setFile(file);
  };

  const handleInputChange = (e, type = "leave-policy", label, data) => {
    if (label && type === "leave-type") {
      setLeaveTypeData((prevState) => ({
        ...prevState,
        [label]: data,
      }));
    } else if (label && type === "leave-policy") {
      setLeavePolicyData((prevState) => ({
        ...prevState,
        [label]: data,
      }));
    } else {
      const { name, value } = e.target;
      if (type === "leave-type") {
        setLeaveTypeData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      } else {
        setLeavePolicyData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    }
  };

  const handleProjectEmployee = async (type) => {
    if (!employee?.value || employee?.value === "") return notify("Please select a employee", "warning");
    setLoading(true);
    const formData = new FormData();
    formData.append("employee", employee?.value);
    formData.append("project", projectId);

    const response = await customAction(id ? `project/employee/${id}/` : `project/employee/`, id ? "patch" : "post", formData, token, "Team");
    if (response) {
      if (type === "saveadd") {
        setEmployee("");
      } else {
        onHide();
      }
      fetchData();
    }
    setLoading(false);
  };

  const handleTeam = async (type) => {
    if (!name || name === "") return notify("Title is required", "warning");
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    const response = await customAction(id ? `employee/team/${id}/` : `employee/team/`, id ? "patch" : "post", formData, token, "Team");
    if (response) {
      if (type === "saveadd") {
        setName("");
      } else {
        onHide();
      }
      setId(null);
      fetchData();
    }
    setLoading(false);
  };

  const handleRole = async (type) => {
    if (!name || name === "") return notify("Title is required", "warning");
    setLoading(true);
    const formData = new FormData();
    formData.append("name", name);
    formData.append("role_type", roleType?.value);

    const response = await customAction(id ? `employee/role/${id}/` : `employee/role/`, id ? "patch" : "post", formData, token, "Team");
    if (response) {
      if (type === "saveadd") {
        setName("");
        setRoleType({ value: "EMPLOYEE", label: "EMPLOYEE" });
      } else {
        onHide();
      }
      setId(null);
      fetchData();
    }
    setLoading(false);
  };

  const handleAddTimesheet = async (type, global = false) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setLoading(true);
    }
    if (file && file?.name?.endsWith(".xlsx")) {
      const formData = new FormData();
      formData.append("file", file);
      !global && formData.append("project", projectId);
      const response = await customAction(
        global ? "project/global-timesheet-upload/" : "project/timesheet/",
        "post",
        formData,
        token,
        "Timesheet",
        true,
      );
      if (response) {
        if (type === "saveadd") {
          setFile("");
        } else {
          onHide();
        }
        fetchData();
      }
    } else {
      if (!file) {
        notify("Please upload a file");
      } else if (!file?.name?.endsWith(".xlsx")) {
        notify("Please upload excel(.xlsx) file");
      }
    }
    setLoading(false);
    setSaveAddLoading(false);
  };

  const handleAddExpense = async (type) => {
    if (type === "saveadd") {
      setSaveAddLoading(true);
    } else {
      setLoading(true);
    }
    if (refNumber && amount && expenseCategory?.value && gstSlab?.value && !(status?.value === "PAID" && !expensePaymentDate)) {
      const formData = new FormData();
      formData.append("ref_number", refNumber);
      formData.append("vendor", vendor?.value || "");
      invoiceDate && formData.append("bill_date", invoiceDate);
      dueDate && formData.append("due_date", dueDate);
      status?.value === "PAID" && expensePaymentDate && formData.append("payment_date", expensePaymentDate);
      formData.append("amount_excl_gst", amount);
      formData.append("category", expenseCategory?.value);
      project?.value && formData.append("project", project?.value);
      status?.value && formData.append("status", status?.value);
      formData.append("remark", remark);
      formData.append("sgst", sgst);
      formData.append("cgst", cgst);
      formData.append("igst", igst);
      formData.append("amount", totalAmount);
      gstSlab?.value && formData.append("gst_slab", gstSlab?.value);
      formData.append("is_rcm_applicable", isRcmApplicable);

      file && typeof selectedImage !== "string" && formData.append("file", file);

      const response = await customAction(
        id ? `expense/expense/${id}/` : `expense/expense/`,
        id ? "patch" : "post",
        formData,
        token,
        "Expense",
        true,
      );
      if (response) {
        // console.log("response", type);
        fetchData();
        if (type === "saveadd") {
          setRefNumber("");
          setVendor("");
          setInvoiceDate("");
          setDueDate("");
          setAmount("");
          setExpensePaymentDate("");
          setProject("");
          setStatus("");
          setFile("");
          setIsRcmApplicable(false);
        } else {
          onHide();
        }
      }
    } else {
      if (!refNumber) {
        notify("Please add ref no.", "warning");
      } else if (!expenseCategory?.value) {
        notify("Please select a category", "warning");
      } else if (!amount) {
        notify("Please enter the amount", "warning");
      } else if (!gstSlab?.value) {
        notify("Please select a GST slab", "warning");
      } else if (status?.value === "PAID" && !expensePaymentDate) {
        notify("Please select payment date", "warning");
      }
    }
    setLoading(false);
    setSaveAddLoading(false);
  };

  const handleRegisterPayment = async (type) => {
    if (
      (invoiceType === "FOREIGN" && amountReceivedInINR && amountPaid && amountPaid >= amountDeducted && modeOfPayment && paymentDate) ||
      (invoiceType !== "FOREIGN" && amountPaid && modeOfPayment && paymentDate)
    ) {
      setLoading(true);
      const shouldProceed = await validateAmountReceivedAgainstRate();
      if (!shouldProceed) {
        setLoading(false);
        return;
      }

      const isForeign = invoiceType === "FOREIGN";
      const formData = new FormData();
      formData.append("invoice", invoiceData ? invoiceData?.id : item?.id);
      formData.append("amount_paid", amountPaid);
      formData.append("register_payment", true);
      if (isForeign) {
        // TDS/GST are only applicable to INR invoices; send explicit zeros so the
        // backend doesn't reject the payment (gstPaid can be NaN or a floating residual).
        formData.append("tds", false);
        formData.append("tds_percent", 0);
        formData.append("gst_paid", 0);
        amountReceivedInINR && formData.append("amount_received_in_inr", amountReceivedInINR);
      } else {
        amountDeducted && formData.append("amount_deducted", amountDeducted);
        tds && formData.append("tds", tds?.value);
        formData.append("tds_percent", tdsPercent && tds?.value ? tdsPercent : 0);
        formData?.append("gst_paid", gstPaid);
      }
      paymentDate && formData.append("payment_date", paymentDate);
      formData?.append("mode_of_payment", modeOfPayment?.label);
      formData?.append("send_receipt", send);
      const response = await customAction(
        action === "edit" ? `invoice/payments/${itemId}/` : `invoice/payments/`,
        action === "edit" ? "put" : "post",
        formData,
        token,
        "Register Payment",
        false,
        // invoiceData ? true : false
      );
      if (response) {
        fetchData();
        onHide();
      }
    } else {
      if (!amountPaid) {
        notify("Please enter the amount paid", "warning");
      } else if (invoiceType === "FOREIGN" && !amountReceivedInINR) {
        notify("Please enter the amount received in INR", "warning");
      } else if (!modeOfPayment) {
        notify("Please select mode of payment", "warning");
      } else if (!paymentDate) {
        notify("Please select payment date", "warning");
      } else if (amountPaid < amountDeducted) {
        notify("Amount Deducted cannot be greater than amount paid", "warning");
      }
    }
    setLoading(false);
  };

  const validateAmountReceivedAgainstRate = async () => {
    if (invoiceType !== "FOREIGN" || !amountPaid || !amountReceivedInINR || !paymentDate) {
      return true;
    }

    const currencyCode = invoiceData?.project_array?.currency?.code || item?.project_array?.currency?.code;
    if (!currencyCode || currencyCode === "INR") {
      return true;
    }

    try {
      const date = paymentDate;
      const url = `https://api.frankfurter.dev/v2/rates?date=${date}&quotes=INR&base=${currencyCode}`;
      const response = await fetch(url);
      if (!response.ok) {
        return true;
      }

      const data = await response.json();
      const rate = Array.isArray(data) ? parseFloat(data[0]?.rate) : parseFloat(data?.rates?.INR);
      if (!rate || isNaN(rate)) {
        return true;
      }

      const expectedInr = parseFloat(amountPaid) * rate;
      const receivedInr = parseFloat(amountReceivedInINR);
      const threshold = expectedInr * 0.01 + 1;

      if (receivedInr <= expectedInr + threshold) {
        return true;
      }

      return window.confirm(
        `Based on the ${currencyCode}→INR rate on ${date} (${rate.toFixed(4)}), expected INR is ${expectedInr.toFixed(2)}. ` +
          `You entered ${receivedInr.toFixed(2)}. Do you want to continue?`,
      );
    } catch (err) {
      return true;
    }
  };

  const handleAddUpdateLeavePolicy = async (type) => {
    if (!leavePolicyData?.year) return notify("Please select a year.", "error");

    if (!leavePolicyData?.total_leave_days) return notify("Total leave days is required", "error");

    const resp = await customAction(
      itemId ? `leave/leave-policy/${itemId}/` : `leave/leave-policy/`,
      itemId ? "put" : "post",
      leavePolicyData,
      token,
      "Register Payment",
      false,
    );
    if (resp) {
      if (type === "saveadd") {
        setLeavePolicyData({
          year: "",
          total_leave_days: "",
        });
      } else {
        onHide();
      }
      fetchData();
    }
  };

  const handleAddUpdateLeaveType = async (type) => {
    if (!leaveTypeData?.name) return notify("Leave Type is required", "error");

    if (!leaveTypeData?.total_leave_days && leavePolicyData?.is_paid) return notify("Total leave days is required", "error");

    if (!leaveTypeData?.leave_policy) return notify("Leave policy is required", "error");

    let data = leaveTypeData;
    if (leaveTypeData?.name?.value) {
      data.name = leaveTypeData?.name?.label;
    }
    if (leavePolicyData?.id) {
      data.id = leavePolicyData?.id;
    }
    const resp = await customAction(
      itemId ? `leave/create-leave-type-and-policy/${itemId}/` : `leave/create-leave-type-and-policy/`,
      itemId ? "put" : "post",
      leaveTypeData,
      token,
      "Leave Type Data",
      false,
    );
    if (resp) {
      if (type === "saveadd") {
        setLeaveTypeData({
          name: "",
          status: true,
          is_paid: true,
          leave_policy: "",
          carry_forward_days: "",
          total_leave_days: "",
        });
      } else {
        onHide();
      }
      fetchData();
    }
  };

  const handleSubmit = (e, type = "save") => {
    e.preventDefault();
    if (title === "Team") {
      handleTeam(type);
    }
    if (title === "Role") {
      handleRole(type);
    }
    if (title === "Document") {
      if (file && name && name !== "") {
        onSubmit(name, file);
        if (type === "saveadd") {
          setName("");
          setFile(null);
        }
      } else {
        if (!name || name === "") {
          notify("Please add document title", "warning");
        } else if (!file) {
          notify("Please add file to continue", "warning");
        }
      }
    }
    if (title === "Timesheet") {
      handleAddTimesheet(type, false);
    }
    if (title === "Timesheets") {
      handleAddTimesheet(type, true);
    }
    if (title === "New Member") {
      handleProjectEmployee(type);
    }
    if (title === "Finance - Expenses" || title === "Expenses" || title === "Expense") {
      handleAddExpense(type);
    }
    if (title === "Register Payment") {
      handleRegisterPayment(type);
    }
    if (title === "Leave Policy" || title === "Leave Policie") {
      handleAddUpdateLeavePolicy(type);
    }
    if (title === "Leave Type") {
      handleAddUpdateLeaveType(type);
    }
  };

  const handleResize = () => {
    setScreenWidth(window.innerWidth);
  };

  return (
    <Modal
      show={show}
      className={`w-100 custom-modal m-0 d-flex flex-column justify-content=center align-items-center  ${
        title === "Finance - Expenses" || title === "Expenses" || title === "Expense" ? "pt-0 mt-0" : "pt-5 mt-5"
      }`}
    >
      <Container
        className="p-3 bg-white br-10"
        style={{
          maxWidth:
            title === "Finance - Expenses" || title === "Expenses" || title === "Expense"
              ? screenWidth >= 768
                ? "none"
                : "100%"
              : title === "Register Payment"
                ? "720px"
                : "100%",
          minWidth:
            title === "Finance - Expenses" || title === "Expenses" || title === "Expense"
              ? screenWidth >= 768
                ? "700px"
                : "100%"
              : title === "Invoice Payment" || title === "Delay Charges"
                ? screenWidth >= 768
                  ? "1080px"
                  : "100%"
                : title === "Document"
                  ? "350px"
                  : title === "Register Payment"
                    ? "720px"
                    : title === "Leave Type"
                      ? "500px"
                      : "auto",
        }}
      >
        <div className="w-100 d-flex justify-content-between align-items-center">
          <div className="fs-20 fw-600">
            {title !== "Register Payment" && title !== "Invoice Payment" && title !== "Delay Charges" ? (id ? `Update ` : `Add `) : ""}
            {title}
          </div>
          <RiCloseCircleLine
            onClick={() => {
              if (title === "Invoice Payment") {
                typeof fetchData === "function" && fetchData();
              }
              onHide();
            }}
            className="text-primary  c-p "
            size={25}
          />
        </div>
        <hr />
        <form onSubmit={handleSubmit} className="d-flex flex-column gap-2 pe-1">
          {title !== "New Member" &&
            title !== "Timesheet" &&
            title !== "Timesheets" &&
            title !== "Finance - Expenses" &&
            title !== "Expenses" &&
            title !== "Expense" &&
            title !== "Register Payment" &&
            title !== "Invoice Payment" &&
            title !== "Delay Charges" &&
            title !== "Leave Policy" &&
            title !== "Leave Policie" &&
            title !== "Leave Type" && (
              <>
                <div className="text-tertiary-dark">{title} Title</div>
                <input
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  className="w-100 rounded custom-input px-3 py-2"
                  required
                  autoComplete="off"
                />
              </>
            )}

          {title == "Role" && (
            <>
              <p className="fs-16 fw-500 mb-2">Type</p>
              <Select
                value={roleType}
                onChange={(selectedOption) => {
                  setRoleType(selectedOption);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "100%",
                    border: "0px !important",
                    boxShadow: "0px !important",
                    backgroundColor: "#EFF6FA",
                    borderRadius: "5px",
                  }),
                }}
                className={`border-0 focus-none  ${roleType === "" && "text-para"}`}
                options={roleTypeOptions?.map((item) => ({
                  value: item,
                  label: item?.split("_").join(" "),
                }))}
                placeholder=""
              />
            </>
          )}

          {title === "Leave Type" && (
            <>
              <div>
                <p className="fs-16 fw-500 mb-2">Leave Type</p>
                <CreatableSelect
                  isClearable
                  value={leaveTypeData?.name || ""}
                  options={leaveTypeOptions}
                  onChange={handleSelectChange}
                  placeholder="Select or enter a leave type"
                  styles={{
                    control: (baseStyles, state) => ({
                      ...baseStyles,
                      width: "100%",
                      border: "0px !important",
                      boxShadow: "0px !important",
                      backgroundColor: "#EFF6FA",
                      borderRadius: "5px",
                    }),
                  }}
                  className={`border-0 focus-none  ${leaveTypeData?.leave_policy === "" && "text-para"}`}
                />
              </div>
              <p className="fs-16 fw-500 mb-2">Paid</p>
              <Select
                value={leaveTypeData?.is_paid ? { value: true, label: "Yes" } : { value: false, label: "No" }}
                onChange={(selectedOption) => {
                  handleInputChange(null, "leave-type", "is_paid", selectedOption?.value);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "100%",
                    border: "0px !important",
                    boxShadow: "0px !important",
                    backgroundColor: "#EFF6FA",
                    borderRadius: "5px",
                  }),
                }}
                className={`border-0 focus-none  ${leaveTypeData?.leave_policy === "" && "text-para"}`}
                options={[
                  { value: true, label: "Yes" },
                  { value: false, label: "No" },
                ]?.map((item) => ({
                  value: item.value,
                  label: item.label,
                }))}
                placeholder=""
              />
              <p className="fs-16 fw-500 mb-2">Select Leave Policy</p>
              <Select
                value={leaveTypeData?.leave_policy ? leavePolicyOptions?.find((i) => i.value === leaveTypeData?.leave_policy) : ""}
                onChange={(selectedOption) => {
                  handleInputChange(null, "leave-type", "leave_policy", selectedOption?.value);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "100%",
                    border: "0px !important",
                    boxShadow: "0px !important",
                    backgroundColor: "#EFF6FA",
                    borderRadius: "5px",
                  }),
                }}
                className={`border-0 focus-none  ${leaveTypeData?.leave_policy === "" && "text-para"}`}
                options={leavePolicyOptions}
                placeholder=""
              />
              <div>
                <p className="fs-16 fw-500 mb-2">Total leave days</p>
                <input
                  name="total_leave_days"
                  value={leaveTypeData?.total_leave_days}
                  onChange={(e) => handleInputChange(e, "leave-type")}
                  type="number"
                  className="w-100 rounded custom-input px-3 py-2"
                  required
                  min={0}
                  onKeyDown={preventInvalidNumberInput}
                  autoComplete="off"
                />
              </div>
              <div>
                <p className="fs-16 fw-500 mb-2">Carry Forward Days</p>
                <input
                  name="carry_forward_days"
                  value={leaveTypeData?.carry_forward_days}
                  onChange={(e) => handleInputChange(e, "leave-type")}
                  type="number"
                  className="w-100 rounded custom-input px-3 py-2"
                  required
                  min={0}
                  onKeyDown={preventInvalidNumberInput}
                  autoComplete="off"
                />
              </div>
              <div>
                <p className="fs-16 fw-500 mb-2">Minimum Notice Days</p>
                <input
                  name="minimum_notice_days"
                  value={leaveTypeData?.minimum_notice_days}
                  onChange={(e) => handleInputChange(e, "leave-type")}
                  type="number"
                  className="w-100 rounded custom-input px-3 py-2"
                  required
                  min={0}
                  onKeyDown={preventInvalidNumberInput}
                  autoComplete="off"
                />
              </div>
              <span className="d-flex align-items-center gap-2">
                {leaveTypeData?.status ? (
                  <MdCheckBox className=" c-p  text-primary" onClick={() => handleInputChange(null, "leave-type", "status", false)} size={20} />
                ) : (
                  <MdCheckBoxOutlineBlank
                    className="c-p text-tertiary-dark"
                    onClick={() => handleInputChange(null, "leave-type", "status", true)}
                    size={20}
                  />
                )}
                <span
                  onClick={() => handleInputChange(null, "leave-type", "status", !leaveTypeData?.status)}
                  className="c-p fs-15 fw-400 text-tertiary-dark"
                >
                  Active
                </span>
              </span>
            </>
          )}

          {title === "Leave Policy" ||
            (title === "Leave Policie" && (
              <>
                <div>
                  <p className="fs-16 fw-500 mb-2">Year</p>
                  <Select
                    value={
                      leavePolicyData?.year
                        ? {
                            value: leavePolicyData?.year,
                            label: leavePolicyData?.year,
                          }
                        : ""
                    }
                    onChange={(selectedOption) => {
                      handleInputChange(null, "leave-policy", "year", selectedOption?.value);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                      }),
                    }}
                    className={`border-0 focus-none  ${leavePolicyData?.year === "" && "text-para"}`}
                    options={[...Array(6)].map((_, index) => {
                      const year = new Date().getFullYear() - 1 + index;
                      return { value: year, label: year };
                    })}
                    placeholder=""
                  />
                </div>
                <div>
                  <p className="fs-16 fw-500 mb-2">Total leave days</p>
                  <input
                    name="total_leave_days"
                    value={leavePolicyData?.total_leave_days}
                    onChange={handleInputChange}
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    required
                    onKeyDown={preventInvalidNumberInput}
                    autoComplete="off"
                  />
                </div>
              </>
            ))}
          {(title === "Document" || title === "Timesheet" || title === "Timesheets") && (
            <div className="w-100">
              <div
                onClick={() => fileInputRef.current.click()}
                className="d-flex align-items-center justify-content-center text-tertiary-dark bg-light p-2 w-100  c-p  br-10"
              >
                <RiImage2Line size={18} className="me-2" /> Upload file Here
              </div>
              {title === "Timesheet" ||
                (title === "Timesheets" && <span className="fs-12"> *Please make sure you are uploading correct timesheet </span>)}
              <div className="fs-14">{truncateString(file?.name, 50)}</div>
              <input
                ref={fileInputRef}
                type="file"
                accept={
                  title === "Timesheet"
                    ? ".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    : ".xls,.xlsx,.csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.pdf,application/pdf,.jpg,.jpeg,.png,.gif,image/*,.txt,text/plain"
                }
                onChange={handleFileChange}
                className="d-none"
              />
            </div>
          )}

          {title === "New Member" && (
            <>
              <p className="fs-16 fw-500 mb-2">Select Member</p>
              <Select
                value={employee}
                onChange={(selectedOption) => {
                  setEmployee(selectedOption);
                }}
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    width: "100%",
                    border: "0px !important",
                    boxShadow: "0px !important",
                    backgroundColor: "#EFF6FA",
                    borderRadius: "5px",
                  }),
                }}
                className={`border-0 focus-none  ${employee === "" && "text-para"}`}
                options={employeeOptions?.map((item) => ({
                  value: item?.id,
                  label: item?.first_name + " " + item?.last_name,
                }))}
                placeholder=""
              />
            </>
          )}

          {(title === "Finance - Expenses" || title === "Expenses" || title === "Expense") && (
            <>
              <div className="d-flex flex-column flex-md-row align-items-start gap-2 w-100 mb-2">
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">
                    Ref No. <RenderAsterisk />
                  </p>
                  <input
                    value={refNumber}
                    onChange={(e) => setRefNumber(e.target.value)}
                    type="text"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="col-12 col-md-6 d-flex flex-column">
                  <p className="fs-16 fw-500 mb-2">Vendor</p>
                  <Select
                    value={vendor}
                    onChange={(selectedOption) => {
                      setVendor(selectedOption);
                    }}
                    filterOption={(option, inputValue) => {
                      return option?.label?.toLowerCase()?.includes(inputValue?.toLowerCase() || "");
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                      }),
                      menuList: (baseStyles, state) => ({
                        ...baseStyles,
                        maxHeight: "120px",
                      }),
                    }}
                    className={`border-0 focus-none  ${vendor === "" && "text-para"}`}
                    options={[
                      ...(vendorOptions || [])?.map((item) => ({
                        value: item?.id,
                        label: item?.name,
                      })),
                    ]}
                    placeholder=""
                  />
                  <div
                    className="fs-12 text-primary c-p mt-2 mb-1 align-self-start lh-sm"
                    onClick={() => window.open("/vendors?openCreateVendor=1&newTab=1", "_blank", "noopener,noreferrer")}
                  >
                    + Add New Vendor
                  </div>
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row  align-items-center gap-2 w-100">
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-2">Invoice Date</p>
                  <input
                    value={invoiceDate}
                    onChange={(e) => setInvoiceDate(e.target.value)}
                    type="date"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="col-12 col-md-6 d-flex flex-column">
                  <p className="fs-16 fw-500 mb-2">Due Date</p>
                  <input
                    value={dueDate}
                    onChange={(e) => setDueDate(e.target.value)}
                    type={"date"}
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row  align-items-center gap-2 w-100">
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">
                    Amount <RenderAsterisk /> <span className="text-grey">(excluding GST)</span>
                  </p>
                  <input
                    value={amount}
                    onChange={(e) => {
                      setAmount(e.target.value);
                    }}
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="col-12 col-md-6 d-flex flex-column">
                  <p className="fs-16 fw-500 mb-2">Project</p>
                  <Select
                    value={project}
                    onChange={(selectedOption) => {
                      setProject(selectedOption);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                        zIndex: 999,
                      }),

                      menuList: (baseStyles, state) => ({
                        ...baseStyles,
                        maxHeight: "150px",
                      }),
                    }}
                    className={`border-0 focus-none  ${project === "" && "text-para"}`}
                    options={projectOptions
                      .filter((item) => {
                        if (item.status !== "COMPLETED") {
                          return true;
                        } else {
                          return project.value && project.value === item.id;
                        }
                      })
                      ?.map((item) => ({
                        value: item?.id,
                        label: item?.title,
                      }))}
                    placeholder=""
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row gap-2 w-100">
                <div className="col-12 col-md-6" style={{ zIndex: 999 }}>
                  <p className="fs-16 fw-500 mb-2">
                    GST Slab <RenderAsterisk />
                  </p>
                  <Select
                    value={gstSlab}
                    onChange={(selectedOption) => {
                      setGstSlab(selectedOption);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                      }),
                      menuList: (baseStyles, state) => ({
                        ...baseStyles,
                        maxHeight: "150px",
                      }),
                    }}
                    className={`border-0 focus-none  ${gstSlab === "" && "text-para"}`}
                    options={gstSlabOptions}
                    placeholder=""
                  />
                  {gstSlab?.value === "0" && (
                    <span className="d-flex align-items-center gap-2 mt-2">
                      {isRcmApplicable ? (
                        <MdCheckBox className=" c-p  text-primary" onClick={() => setIsRcmApplicable(false)} size={20} />
                      ) : (
                        <MdCheckBoxOutlineBlank className="c-p text-tertiary-dark" onClick={() => setIsRcmApplicable(true)} size={20} />
                      )}
                      <span onClick={() => setIsRcmApplicable(!isRcmApplicable)} className="c-p fs-15 fw-400 text-tertiary-dark">
                        Is RCM Applicable
                      </span>
                    </span>
                  )}
                </div>
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">SGST</p>
                  <input
                    value={sgst}
                    onChange={(e) => {
                      setSgst(e.target.value);
                    }}
                    disabled
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row gap-2 w-100">
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">CGST</p>
                  <input
                    value={cgst}
                    onChange={(e) => {
                      setCgst(e.target.value);
                    }}
                    disabled
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">IGST</p>
                  <input
                    value={igst}
                    onChange={(e) => {
                      setIgst(e.target.value);
                    }}
                    disabled
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row align-items- gap-2 w-100">
                <div className="d-flex flex-column gap-1 col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-1">Total Amount</p>
                  <input
                    value={totalAmount}
                    onChange={(e) => {
                      setTotalAmount(e.target.value);
                    }}
                    disabled
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                <div className="col-12 col-md-6" style={{ zIndex: 99 }}>
                  <p className="fs-16 fw-500 mb-2">
                    Category <RenderAsterisk />
                  </p>
                  <Select
                    value={expenseCategory}
                    onChange={(selectedOption) => {
                      setExpenseCategory(selectedOption);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                      }),
                      menuList: (baseStyles, state) => ({
                        ...baseStyles,
                        maxHeight: "200px",
                      }),
                    }}
                    className={`border-0 focus-none  ${expenseCategory === "" && "text-para"}`}
                    options={expenseCategoyrOptions?.map((item) => ({
                      value: item.id,
                      label: item.name,
                    }))}
                    placeholder=""
                  />
                </div>
              </div>
              <div className="d-flex flex-column flex-md-row align-items- gap-2 w-100">
                <div className="col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-2">Status</p>
                  <Select
                    value={status}
                    onChange={(selectedOption) => {
                      setStatus(selectedOption);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                        zIndex: 999,
                      }),
                    }}
                    className={`border-0 focus-none ${status === "" && "text-para"}`}
                    options={statusOptions?.map((item) => ({
                      value: item,
                      label: item,
                    }))}
                    placeholder=""
                  />
                </div>
                <div className="col-12 col-md-6">
                  <p className="fs-16 fw-500 mb-2">Bill</p>
                  <div
                    onClick={() => fileInputRef.current.click()}
                    style={{ height: "38px" }}
                    className=" d-flex align-items-center justify-content-center text-tertiary-dark bg-light px-2 w-100  c-p  br-5"
                  >
                    <RiImage2Line size={18} className="me-2" /> Upload Bill Here
                  </div>
                  <div className="d-flex gap-2">
                    {file && (
                      <div className="fs-14">
                        {isImage(typeof file === "string" ? file?.split("/")?.pop() : file?.name) ? (
                          <img
                            src={typeof file === "string" ? getMediaUrl(file) : URL.createObjectURL(file)}
                            alt=""
                            className="br-50"
                            style={{
                              height: "20px",
                              width: "20px",
                            }}
                          />
                        ) : (
                          <RiFile2Line size={22} />
                        )}
                      </div>
                    )}
                    <div className="fs-14">{typeof file === "string" ? file?.split("/")?.pop() : file?.name}</div>
                  </div>

                  <input ref={fileInputRef} type="file" onChange={handleFileChange} className="d-none" />
                </div>
              </div>

              {status?.value === "PAID" && (
                <div className="d-flex flex-column gap-2 w-100">
                  <div className="col-12 d-flex flex-column">
                    <p className="fs-16 fw-500 mb-2">
                      Payment Date <RenderAsterisk />
                    </p>
                    <input
                      value={expensePaymentDate}
                      onChange={(e) => setExpensePaymentDate(e.target.value)}
                      type="date"
                      className="w-100 rounded custom-input px-3 py-2"
                      required
                      autoComplete="off"
                    />
                  </div>
                </div>
              )}
              <div className="col-12" style={{ zIndex: 0 }}>
                <p className="fs-16 fw-500 mb-2">Remarks</p>
                <CKEditor
                  editor={ClassicEditor}
                  data={remark}
                  onChange={(event, editor) => {
                    const data = editor.getData();
                    setRemark(data);
                  }}
                  config={ckEditorConfiguration}
                  className="br-10"
                />
              </div>
            </>
          )}

          {title === "Register Payment" && (
            <>
              <div className="d-flex align-items-center gap-2 w-100">
                <div className="col-6 d-flex gap-1 align-items-center">
                  Invoice No. <div className="fw-600"> {invoiceData ? invoiceData?.invoice_number : item?.invoice_number}</div>
                </div>
                <div className="col-6 d-flex gap-1 align-items-center">
                  Total Amount.{" "}
                  <div className="fw-600">
                    {formatPrice(
                      invoiceData ? invoiceData?.total : item?.total,
                      invoiceData ? invoiceData?.project_array?.currency?.code : item?.project_array?.currency?.code,
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center gap-2 w-100">
                <div className="col-6 d-flex gap-1 align-items-center">
                  Client.{" "}
                  <div className="fw-600">
                    {invoiceData ? invoiceData?.project_array?.client_array?.name : item?.project_array?.client_array?.name}
                  </div>
                </div>
                <div className="col-6 d-flex gap-1 align-items-center">
                  Project Name. <div className="fw-600">{invoiceData ? invoiceData?.project_array?.title : item?.project_array?.title}</div>
                </div>
              </div>
              {item?.remaining_amount && (
                <div className="d-flex align-items-center gap-2 w-100">
                  <div className="col-6 d-flex gap-1 align-items-center">
                    Remaining Amount.{" "}
                    <div className="fw-600">
                      {formatPrice(
                        (parseFloat(invoiceData ? invoiceData?.remaining_amount : item?.remaining_amount) || 0) - (parseFloat(amountPaid) || 0),
                        invoiceData?.project_array?.currency?.code ? invoiceData?.project_array?.currency?.code : item?.project_array?.currency?.code,
                      )}
                    </div>
                  </div>
                </div>
              )}
              <div className="d-flex align-items-center w-100 mt-3 flex-wrap">
                <div className="d-flex flex-column gap-1 col-6 p-1">
                  <p className="fs-16 fw-500 mb-1">
                    Amount Paid (in{" "}
                    {invoiceData
                      ? invoiceData?.project_array?.currency?.code
                      : item?.project_array?.currency?.code
                        ? item?.project_array?.currency?.code
                        : ""}
                    )
                  </p>
                  <input
                    value={amountPaid}
                    onChange={(e) => {
                      const value = e.target.value;
                      const formattedValue = value?.includes(".") ? value?.split(".")[0] + "." + value?.split(".")[1].slice(0, 2) : value;

                      setAmountPaid(formattedValue);
                    }}
                    type="number"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
                {invoiceType === "FOREIGN" && (
                  <div className="d-flex flex-column gap-1 col-6 p-1">
                    <p className="fs-16 fw-500 mb-1">Amount Received in INR</p>
                    <input
                      value={amountReceivedInINR}
                      onChange={(e) => {
                        const value = e.target.value;
                        const formattedValue = value?.includes(".") ? value?.split(".")[0] + "." + value?.split(".")[1].slice(0, 2) : value;
                        setAmountReceivedInINR(formattedValue);
                      }}
                      type="number"
                      className="w-100 rounded custom-input px-3 py-2"
                      placeholder=""
                      required
                      autoComplete="off"
                    />
                  </div>
                )}
                {invoiceType !== "FOREIGN" && (
                  <>
                    <div className="col-6 p-1">
                      <p className="fs-16 fw-500 mb-2">TDS Deducted</p>
                      <Select
                        value={tds}
                        onChange={(selectedOption) => {
                          setTds(selectedOption);
                        }}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            width: "100%",
                            border: "0px !important",
                            boxShadow: "0px !important",
                            backgroundColor: "#EFF6FA",
                            borderRadius: "5px",
                          }),
                        }}
                        className={`w-100 border-0 focus-none  ${tds === "" && "text-para"}`}
                        options={[
                          { value: true, label: "Yes" },
                          { value: false, label: "No" },
                        ]?.map((item) => ({
                          value: item.value,
                          label: item.label,
                        }))}
                        placeholder=""
                      />
                    </div>
                  </>
                )}
                {invoiceType !== "FOREIGN" && tds?.value && (
                  <>
                    <div className="col-6 p-1 ">
                      <p className="fs-16 fw-500 mb-1">TDS Percent</p>
                      <input
                        disabled={!tds?.value}
                        value={tdsPercent}
                        onChange={(e) => {
                          setTdsPercent(e.target.value);
                        }}
                        type="number"
                        className="w-100 rounded custom-input px-3 py-2"
                        placeholder=""
                        required
                        autoComplete="off"
                      />
                    </div>
                    <div className="col-6 p-1 ">
                      <p className="fs-16 fw-500 mb-1">Amount Deducted</p>
                      <input
                        disabled
                        value={amountDeducted}
                        onChange={(e) => setAmountDeducted(e.target.value)}
                        type="number"
                        className="w-100 rounded custom-input px-3 py-2"
                        placeholder=""
                        required
                        autoComplete="off"
                      />
                    </div>
                  </>
                )}
                <div className="col-6 p-1 ">
                  <p className="fs-16 fw-500 mb-2">Mode of Payment</p>
                  <Select
                    value={modeOfPayment}
                    onChange={(selectedOption) => {
                      setModeOfPayment(selectedOption);
                    }}
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: "100%",
                        border: "0px !important",
                        boxShadow: "0px !important",
                        backgroundColor: "#EFF6FA",
                        borderRadius: "5px",
                      }),
                    }}
                    className={`border-0 focus-none  ${modeOfPayment === "" && "text-para"}`}
                    options={modeOptions?.map((item) => ({
                      value: item?.value,
                      label: item?.label,
                    }))}
                    placeholder=""
                  />
                </div>
                <div className="d-flex flex-column gap-1 col-6 p-1">
                  <p className="fs-16 fw-500 mb-1">Payment Date</p>
                  <input
                    value={paymentDate}
                    onChange={(e) => setPaymentDate(e.target.value)}
                    type="date"
                    className="w-100 rounded custom-input px-3 py-2"
                    placeholder=""
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              <span className="d-flex align-items-center gap-2">
                {send ? (
                  <MdCheckBox className=" c-p  text-primary" onClick={() => setSend(false)} size={20} />
                ) : (
                  <MdCheckBoxOutlineBlank
                    className="c-p text-tertiary-dark"
                    onClick={() => {
                      setSend(true);
                    }}
                    size={20}
                  />
                )}
                <span onClick={() => setSend(!send)} className="c-p fs-15 fw-400 text-tertiary-dark">
                  Send Reciept
                </span>
              </span>
            </>
          )}

          {title === "Invoice Payment" && (
            <CustomTable
              filters={[]}
              rowActions={["edit", "delete"]}
              rowHeadings={invoicePaymentRowHeadings}
              backendUrl={`invoice/payments?invoice=${itemId}`}
              deleteUrl={"invoice/payments"}
              title="Invoice Payment"
              fetchAgain={fetchAgain}
              setFetchAgain={setFetchAgain}
            />
          )}

          {title !== "Invoice Payment" && title !== "Delay Charges" && (
            <div className="mt-2 d-flex flex-column flex-md-row justify-content-center align-items-center gap-3 mb-5 mb-md-0">
              <Button className="bg-light text-primary border-primary" onClick={onHide} disabled={loading}>
                Close
              </Button>
              {title !== "Document" && title !== "Register Payment" && title !== "Timesheets" && title !== "Timesheets" && (
                <Button
                  disabled={loading || saveAddLoading}
                  onClick={(e) => handleSubmit(e, "saveadd")}
                  className="bg-white border-primary text-primary"
                >
                  {saveAddLoading && <Spinner size="sm" />}
                  Save and Add New
                </Button>
              )}
              <Button disabled={loading || saveAddLoading} onClick={(e) => handleSubmit(e, "save")}>
                {loading ? (
                  <div>
                    <Spinner size="sm" />
                    <span> Saving</span>
                  </div>
                ) : (
                  <span>Save</span>
                )}
              </Button>
            </div>
          )}
        </form>
      </Container>
    </Modal>
  );
};

export default CustomAddBox;
